import React, {Component} from 'react';

import {FormInput} from '@homeaway/react-form-components';
import {validateName} from '../../../utils/validations';
import {DebounceInput} from 'react-debounce-input';

export default class NameInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: true,
            errorMsg: ''
        };
    }

    verify = (name) => {
        const nameError = validateName(name);
        if (nameError) {
            this.setState({errorMsg: nameError});
        }
    }

    handleFocus = () => {
        this.setState({errorMsg: ''}); // clear on focus
    }

    handleBlur = (e) => {
        const name = e.target.value;
        this.verify(name);
    }

    handleChange = (e) => {
        const name = e.target.value;
        this.props.input.onChange(name);
    }

    render() {
        const {value} = this.props.input;
        const {errorMsg} = this.state;
        const {label, id} = this.props;
        const {error} = this.props.meta;
        const errorText = error || errorMsg;
        return (
            <DebounceInput
                debounceTimeout={300}
                element={FormInput}
                id={id}
                type="text"
                name={id}
                label={label}
                errorMsg = {errorText}
                value = {value}
                onBlur = {this.handleBlur}
                onChange={this.handleChange}
                onFocus ={this.handleFocus}
            />
        );
    }
}
